// The UX4G accessibility widget (loaded in public/index.html) injects its own
// launcher button into the page with id="uw-widget-custom-trigger" once its
// script finishes loading, and wires a plain click listener on it that opens
// the panel. The "Ctrl+F2" text shown in the panel's header is decorative only
// - confirmed by reading the widget's actual source, it contains zero
// references to F2 anywhere, so there is no real keyboard shortcut to trigger.
// Our own header/auth-bar accessibility icon has no relationship to that
// button, so this clicks it directly to open the panel instead.
export const openAccessibilityWidget = (): void => {
  const trigger = document.getElementById("uw-widget-custom-trigger");
  if (trigger) {
    trigger.click();
  } else {
    // The widget script (external CDN, loaded async) has not finished
    // loading yet - retry shortly instead of silently doing nothing.
    setTimeout(() => {
      document.getElementById("uw-widget-custom-trigger")?.click();
    }, 1000);
  }
};
